import { render, staticRenderFns } from "./EditableItemProperty.vue?vue&type=template&id=64acf448&scoped=true&"
import script from "./EditableItemProperty.vue?vue&type=script&lang=js&"
export * from "./EditableItemProperty.vue?vue&type=script&lang=js&"
import style0 from "./EditableItemProperty.vue?vue&type=style&index=0&id=64acf448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acf448",
  null
  
)

component.options.__file = "EditableItemProperty.vue"
export default component.exports